"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[19931],{

/***/ 937420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LeftRightStickyBannerBlock": function() { return /* binding */ LeftRightStickyBannerBlock; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212951);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(428247);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  margin-top: 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  position: absolute;\n  right: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  left: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  margin-left: auto;\n  margin-right: auto;\n  width: 1264px;\n  z-index: -1;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  object-fit: fill;\n  width: 100%;\n  height: 100%;\n  transition: transform 0.4s;\n  &:hover {\n    transform: scale(1.05);\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




const StickyBannerImg = (_param)=>{
    var { width , height , url , image  } = _param, rest = _objectWithoutProperties(_param, [
        "width",
        "height",
        "url",
        "image"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Banner, _objectSpreadProps(_objectSpread({
        width: width,
        height: height
    }, rest), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: url,
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledImg, {
                src: image
            })
        })
    }));
};
const LeftRightStickyBannerBlock = (param)=>{
    let { leftBlock , rightBlock , stickyTop =72  } = param;
    const leftBanners = leftBlock === null || leftBlock === void 0 ? void 0 : leftBlock.cookedData;
    const rightBanners = rightBlock === null || rightBlock === void 0 ? void 0 : rightBlock.cookedData;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StickyWrapper, {
        stickyTop: stickyTop,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BannerListLeft, {
                    children: leftBanners === null || leftBanners === void 0 ? void 0 : leftBanners.map((banner)=>{
                        var ref, ref1;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                            children: banner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StickyBannerImg, _objectSpread({
                                width: (ref = banner.imageSize) === null || ref === void 0 ? void 0 : ref.width,
                                height: (ref1 = banner.imageSize) === null || ref1 === void 0 ? void 0 : ref1.height,
                                url: banner.url,
                                image: banner.image
                            }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_2__/* .getTrackingData */ .O5)({
                                regionName: "leftStickBanner",
                                contentName: (leftBlock === null || leftBlock === void 0 ? void 0 : leftBlock.name) || "",
                                target: banner.url,
                                isTrackContent: true
                            })))
                        }, banner.id);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Middle, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BannerListRight, {
                    children: rightBanners === null || rightBanners === void 0 ? void 0 : rightBanners.map((banner)=>{
                        var ref, ref1;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                            children: banner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StickyBannerImg, _objectSpread({
                                width: (ref = banner.imageSize) === null || ref === void 0 ? void 0 : ref.width,
                                height: (ref1 = banner.imageSize) === null || ref1 === void 0 ? void 0 : ref1.height,
                                url: banner.url,
                                image: banner.image
                            }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_2__/* .getTrackingData */ .O5)({
                                regionName: "rightStickBanner",
                                contentName: (rightBlock === null || rightBlock === void 0 ? void 0 : rightBlock.name) || "",
                                target: banner.url,
                                isTrackContent: true
                            })))
                        }, banner.id);
                    })
                })
            ]
        })
    });
};
const StickyWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div((param)=>{
    let { stickyTop  } = param;
    return "\n    position: sticky;\n    top: ".concat(stickyTop, "px;\n    display: flex;\n    justify-content: center;\n");
});
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div(_templateObject());
const Banner = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div((param)=>{
    let { width , height  } = param;
    return "\n    margin-bottom: 16px;\n    width: ".concat(width || 150, "px;\n    height: ").concat(height || 350, "px;\n");
});
const BannerListLeft = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div(_templateObject1());
const BannerListRight = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div(_templateObject2());
const Middle = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div(_templateObject3());
const StyledImg = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].img(_templateObject4());


/***/ })

}]);